import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Loading from "../Loading";
import { MenuItem, Select } from "@mui/material";

const AddCategory = ({ setAddFoodCategory, addCategoryLoading, addCategoryMutate }) => {
  const InitialValue = {
    name: "",
    priority: "",
    // item: "",
    // unit: "",
  };
  const formValidation = Yup.object().shape({
    name: Yup.string().required("Please enter category"),
    priority: Yup.string().required("Please enter priority"),
    // category: Yup.string().required("Please select category"),
    // item: Yup.string().required("Please enter item"),
    // unit: Yup.string().required("Please enter unit"),
    // unit: Yup.string().required("Please select unit"),
  });

  const postData = (values) => {
    addCategoryMutate(values);
  };
  const categoryForm = useFormik({
    initialValues: InitialValue,
    validationSchema: formValidation,
    onSubmit: postData,
  });
  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setAddFoodCategory}>
      {addCategoryLoading ? (
        <Loading />
      ) : (
        <Wrapper>
          <Title>Add Category</Title>
          <form onSubmit={categoryForm.handleSubmit}>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="name">Category</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Enter category name"
                    onChange={categoryForm.handleChange}
                    value={categoryForm.values.name}
                  />
                  {categoryForm.touched.name && categoryForm.errors.name ? (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.name}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                  <Label htmlFor="priority">Priority</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="priority"
                      placeholder="Enter priority"
                      onChange={(e) => {
                        const { value } = e.target;
                        if (
                          /^\d{0,3}$/.test(value) &&
                          (value === "" ||
                            (Number(value) >= 1 && Number(value) <= 100))
                        ) {
                          categoryForm.handleChange(e);
                        }
                      }}
                      value={categoryForm.values.priority}
                    />
                    {categoryForm.touched.priority &&
                    categoryForm.errors.priority ? (
                      <p className="text-rose-600 text-sm">
                        {categoryForm.errors.priority}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              {/* <InputGroup>
                <Label htmlFor="category">Category</Label>

                <Select
                    className="w-full pl-2 rounded-lg"
                    name="category"
                    value={categoryForm.values.category}
                    onChange={categoryForm.handleChange}
                    onBlur={categoryForm.handleBlur}
                    displayEmpty
                    MenuProps={{
                        PaperProps: {
                        style: {
                            maxHeight: "40vh",
                            overflowY: "auto",
                        },
                        },
                    }}
                >
                    <MenuItem value="">Select category</MenuItem>

                    <MenuItem value="Grains">Grains</MenuItem>
                    <MenuItem value="Pulses">Pulses</MenuItem>
                    <MenuItem value="Vegetables">Vegetables</MenuItem>
                    <MenuItem value="Fruits">Fruits</MenuItem>
                    <MenuItem value="Eggs & Dairy">Eggs & Dairy</MenuItem>
                    <MenuItem value="Oil & Ghee">Oil & Ghee</MenuItem>
                    <MenuItem value="Spices">Spices</MenuItem>
                    <MenuItem value="Tea & Coffee">Tea & Coffee</MenuItem>
                    <MenuItem value="Meat & Seafood">Meat & Seafood</MenuItem>
                    <MenuItem value="Snacks">Snacks</MenuItem>
                    <MenuItem value="Sweeteners">Sweeteners</MenuItem>
                    <MenuItem value="Baking">Baking</MenuItem>
                    <MenuItem value="Cleaning">Cleaning</MenuItem>
                    <MenuItem value="Packaging">Packaging</MenuItem>
                    <MenuItem value="Kitchen">Kitchen</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                </Select>

                {categoryForm.touched.category && categoryForm.errors.category && (
                    <p className="text-rose-600 text-sm">
                    {categoryForm.errors.category}
                    </p>
                )}
                </InputGroup> */}

              {/* <CombineInputGroup>
                <InputGroup>
                <Label htmlFor="item">Item</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="item"
                    placeholder="Enter item name"
                    onChange={categoryForm.handleChange}
                    value={categoryForm.values.item}
                  />
                  {categoryForm.touched.item &&
                  categoryForm.errors.item ? (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.item}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="unit">Unit</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="unit"
                    placeholder="Enter unit name"
                    onChange={categoryForm.handleChange}
                    value={categoryForm.values.unit}
                  />
                  {categoryForm.touched.unit &&
                  categoryForm.errors.unit ? (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.unit}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="unit">Unit</Label>
                <Select
                    className="w-full pl-2 rounded-lg"
                    name="unit"
                    value={categoryForm.values.unit}
                    onChange={categoryForm.handleChange}
                    onBlur={categoryForm.handleBlur}
                    displayEmpty
                    MenuProps={{
                        PaperProps: {
                        style: {
                            maxHeight: "35vh",
                            overflowY: "auto",
                        },
                        },
                    }}
                >
                    <MenuItem value="">Select unit</MenuItem>
                    <MenuItem value="Kg">Kg</MenuItem>
                    <MenuItem value="Gram">Gram</MenuItem>
                    <MenuItem value="Litre">Litre</MenuItem>
                    <MenuItem value="Ml">Ml</MenuItem>
                    <MenuItem value="Piece">Piece</MenuItem>
                    <MenuItem value="Packet">Packet</MenuItem>
                    <MenuItem value="Bottle">Bottle</MenuItem>
                    <MenuItem value="Box">Box</MenuItem>
                    <MenuItem value="Dozen">Dozen</MenuItem>
                    <MenuItem value="Bag">Bag</MenuItem>
                    <MenuItem value="Crate">Crate</MenuItem>
                </Select>

                {categoryForm.touched.unit && categoryForm.errors.unit && (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.unit}
                    </p>
                )}
                </InputGroup>
              </CombineInputGroup> */}
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Submit</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const ErrorText = tw.div`text-red-500 text-sm`;
const CombineInputGroup = tw.div`flex space-x-7`;

export default AddCategory;
